/**
 * STL "Please Select" color default (Asana "STL - Color Attribute Images - dev (round 3/4)"
 * 1216569565481408 / 1216635941269933).
 *
 * On color-configuration products, the color dropdown defaults to "Please Select" (no color
 * pre-chosen) — see snippets/color-dropdown-custom.liquid. That forces the shopper to actively
 * choose a color (and fixes the first/default color not showing its image on selection).
 *
 * Round 4 (Asana 1216635941269933 #2): Malik didn't want a grayed-out Add to Cart + a persistent
 * "please select a color" message. Instead, leave Add to Cart fully clickable; if the shopper taps
 * it (or submits the form) before choosing a color, block the add and show the prompt + open the
 * color dropdown so they can pick. The message clears the moment a color is selected, after which
 * the theme's own variant-change logic owns the button/price. Inert unless a
 * custom-color-dropdown[data-please-select] is present.
 */
(function () {
  'use strict';

  if (!document.querySelector('custom-color-dropdown[data-please-select]')) return;

  var NOTE_TEXT = 'Please select a color';

  // Live check — robust to the theme re-rendering variant-selects on selection. Once a color is
  // chosen the re-rendered dropdown no longer carries data-please-select, so this returns false.
  function isGated() {
    return !!document.querySelector('custom-color-dropdown[data-please-select]');
  }

  function colorDropdown() {
    return document.querySelector('custom-color-dropdown[data-please-select]');
  }

  function ensureStyle() {
    if (document.getElementById('stl-please-select-style')) return;
    var s = document.createElement('style');
    s.id = 'stl-please-select-style';
    s.textContent =
      '.stl-ps-note{display:block;width:100%;margin:0 0 1rem;font-size:1.3rem;' +
      'font-weight:600;color:#c0392b;}';
    document.head.appendChild(s);
  }

  // Full-width prompt placed ABOVE the quantity/Add-to-Cart row (not squeezed into the button cell).
  function showNote() {
    ensureStyle();
    var btn = document.querySelector('.product-form__submit:not(.sticky-atc .product-form__submit)') ||
      document.querySelector('.product-form__submit');
    if (!btn) return;
    var row = btn.closest('.product-form__buttons') || btn.parentElement;
    var container = row && row.parentElement;
    if (!container) return;
    if (container.querySelector('.stl-ps-note')) return;
    var note = document.createElement('div');
    note.className = 'stl-ps-note';
    note.setAttribute('role', 'status');
    note.textContent = NOTE_TEXT;
    container.insertBefore(note, row);
  }

  function clearNote() {
    document.querySelectorAll('.stl-ps-note').forEach(function (n) { n.remove(); });
  }

  // Nudge the shopper to the color picker: open it and scroll it into view.
  function focusColorPicker() {
    var dd = colorDropdown();
    if (!dd) return;
    var trigger = dd.querySelector('.custom-color-dropdown__trigger');
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') {
      try { trigger.click(); } catch (e) {}
    }
    try { dd.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }

  function block(e) {
    if (!isGated()) return; // color chosen — let the add-to-cart proceed normally
    e.preventDefault();
    e.stopImmediatePropagation();
    showNote();
    focusColorPicker();
  }

  // Intercept in the CAPTURE phase (document is outermost) so we run before the theme's add-to-cart
  // handlers and can cancel the add. Covers the main Add to Cart and the sticky bar (both are
  // .product-form__submit), plus Enter-key form submits.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-form__submit');
    if (btn) block(e);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.querySelector && form.querySelector('.product-form__submit')) block(e);
  }, true);

  // Clear the prompt and lift the gate the instant a color is selected. The custom dropdown
  // dispatches `change` on its hidden input synchronously on selection; dropping data-please-select
  // here makes Add to Cart live immediately (rather than waiting for the theme's async re-render,
  // which also renders the dropdown without the attribute).
  document.addEventListener('change', function (e) {
    var dd = e.target.closest && e.target.closest('custom-color-dropdown');
    if (dd && e.target.value) {
      dd.removeAttribute('data-please-select');
      clearNote();
    }
  }, true);
})();
